import React, { useState } from 'react';
import { useLocation } from 'react-router-dom';
import { handleOtpVerify } from '../../common/atoms/Login/login.util';
import { useAuthContext } from '../../providers/auth-provider';
import { OneTimePassword } from '../../common/atoms/Login/OneTimePassword';

const environmentUrl = import.meta.env.VITE_API_BASEURL || '';

const OneTimePasswordContainer = () => {
  const { afterLogin } = useAuthContext();
  const location = useLocation();

  const [errorMessage, setErrorMessage] = useState(null);

  const doAfterLogin = async (loginResponse) => {
    try {
      await afterLogin(loginResponse);
    } catch {
      setErrorMessage('Error getting user information');
    }
  };

  const handleOtpSubmission = async (code) => {
    try {
      setErrorMessage(null);
      const phone = location.state?.phone;
      const response = await handleOtpVerify(code, phone, environmentUrl);

      if (!response.ok) {
        throw new Error('Error verifying code');
      }

      const otpResponse = await response.json();

      return await doAfterLogin({ access_token: otpResponse.token });
    } catch (error) {
      console.error(error);
      setErrorMessage(error.message);
      return null;
    }
  };

  const clearError = () => {
    setErrorMessage(null);
  };

  return (
    <OneTimePassword
      handleOtpCode={handleOtpSubmission}
      errorMessage={errorMessage}
      environmentUrl={environmentUrl}
      clearError={clearError}
    />
  );
};

export default OneTimePasswordContainer;
